import { Center, Group, Table, Text, UnstyledButton } from "@mantine/core";
import classes from "./Thead.module.scss";
import { IconChevronDown, IconChevronUp, IconSelector } from "@tabler/icons-react";

const Th = (props) => {
  const {
    children,
    reversed,
    sorted,
    onSort,
    onClick,
    colSpan = 1,
    index,
    column,
    style,
    className=[],
    ...restProps
  } = props;
  // const { classes } = useStyles();
  const Icon = sorted
    ? reversed
      ? IconChevronUp
      : IconChevronDown
    : IconSelector;
  // logger.log(column, column.getSize(), column.getCanSort());

  return (
    <Table.Th
      className={[classes.th,...className]}
      key={index}
      {...restProps}
      style={{
        ...getCommonPinningStyles(column),
        //   width: column.getSize() ? column.getSize() : 100,
        ...style,
      }}
    >
      {column.getCanSort() ? (
        <UnstyledButton onClick={onClick} className={classes.control}>
          <Group justify="space-between">
            <div>{children}</div>
            <Center className={classes.icon}>
              <Icon size="0.9rem" stroke={1.5} />
            </Center>
          </Group>
        </UnstyledButton>
      ) : (
        <>{children}</>
      )}
    </Table.Th>
  );
};

export default Th;

const getCommonPinningStyles = (column) => {
  const isPinned = column.getIsPinned();
  const isLastLeftPinnedColumn =
    isPinned === "left" && column.getIsLastColumn("left");
  const isFirstRightPinnedColumn =
    isPinned === "right" && column.getIsFirstColumn("right");

  return {
    boxShadow: isLastLeftPinnedColumn
      ? "-4px 0 4px -4px gray inset"
      : isFirstRightPinnedColumn
      ? "4px 0 4px -4px gray inset"
      : undefined,
    left: isPinned === "left" ? `${column.getStart("left")}px` : undefined,
    right: isPinned === "right" ? `${column.getAfter("right")}px` : undefined,
    opacity: isPinned ? 0.95 : 1,
    position: isPinned ? "sticky" : "relative",
    width: column.getSize(),
    zIndex: isPinned ? 1 : 0,
    // background: 'white'
  };
};
